module.exports = __webpack_public_path__ + "static/index/img/baikal-408.a31905de.jpg";